
import useTranslation from "./Hooks/UseTranslation";

type Submenu = {
    text: string;
    path: string;
    icon: string;
    active: boolean;
}

type Menu = {
    text: string;
    textWidth: number;
    path: string;
    icon: string;
    active: boolean;
    submenu?: Submenu[];
    disabled?: boolean;
}

type Navigation = [
    Menu[],
    Submenu[]
]

const getNavigation = (project_id: string, active_menu: string, active_submenu: string): Navigation => {

    const { t } = useTranslation()

    let menu: any
    let submenu: any

    if (active_menu === 'homepage') {

        menu = []

        submenu = [
            {
                text: t('NAVIGATION:HomeActiveProjects'),
                path: `/`,
                icon: `icon-mis_proyectos`,
                active: active_submenu === 'my_projects',
            },
            {
                text: t('NAVIGATION:HomeArchivedProjects'),
                path: `/other-projects`,
                icon: `icon-otros_proyectos`,
                active: active_submenu === 'other_projects',
            },
        ]

        return [ menu, submenu ]
    }


    if (!project_id) return [[], []]

    menu = [
        {
            text: t('NAVIGATION:Project'),
            textWidth: 55,
            path: `/project/${project_id}/`,
            icon: `icon-proyecto`,
            active: active_menu === 'home',
            submenu: [
                {
                    text: t('NAVIGATION:ProjectDashboard'),
                    path: `/project/${project_id}/`,
                    icon: `icon-dashboard`,
                    active: active_submenu === 'dashboard',
                },
                {
                    text: t('NAVIGATION:ProjectInfo'),
                    path: `/project/${project_id}/info`,
                    icon: `icon-informacion`,
                    active: active_submenu === 'info',
                },
                // {
                //     text: 'Alertas',
                //     path: `/project/${project_id}/alerts`,
                //     icon: `icon-alertas`,
                //     active: active_submenu === 'alerts',
                //     disabled: true,
                // },
            ],
        },
        {
            text: t('NAVIGATION:Teams'),
            textWidth: 50,
            path: `/project/${project_id}/teams`,
            icon: `icon-equipos`,
            active: active_menu === 'teams',
        },
        {
            text: t('NAVIGATION:Programmation'),
            textWidth: 86,
            path: `/project/${project_id}/programmation-macro`,
            icon: `icon-programacion`,
            active: active_menu === 'programmation',
            submenu: [
                {
                    text: t('NAVIGATION:ProgrammationMacro'),
                    path: `/project/${project_id}/programmation-macro`,
                    icon: `icon-macro`,
                    active: active_submenu === 'macro',
                },
                {
                    text: t('NAVIGATION:ProgrammationLookahead'),
                    path: `/project/${project_id}/programmation-lookahead`,
                    icon: `icon-lookahead`,
                    active: active_submenu === 'lookahead',
                },
                {
                    text: t('NAVIGATION:ProgrammationWeekly'),
                    path: `/project/${project_id}/programmation-weekly`,
                    icon: `icon-semanal`,
                    active: active_submenu === 'weekly',
                },
                // {
                //     text: 'Calendario',
                //     path: `/project/${project_id}/programmation-calendar`,
                //     icon: `icon-calendario`,
                //     active: active_submenu === 'calendar',
                //     disabled: true,
                // },
            ],
        },
        {
            text: t('NAVIGATION:Tasks'),
            textWidth: 41,
            path: `/project/${project_id}/tasks`,
            icon: `icon-tareas`,
            active: active_menu === 'tasks',
            submenu: [
                {
                    text: t('NAVIGATION:TasksBoard'),
                    path: `/project/${project_id}/tasks`,
                    icon: `icon-tablero`,
                    active: active_submenu === 'board',
                },
                {
                    text: t('NAVIGATION:TasksDataBase'),
                    path: `/project/${project_id}/tasks-archive`,
                    icon: `icon-base_de_datos`,
                    active: active_submenu === 'archive',
                },
            ],
        },
        {
            text: t('NAVIGATION:Resources'),
            textWidth: 57,
            path: `/project/${project_id}/resources/restrictions`,
            icon: `icon-recursos`,
            active: active_menu === 'resources',
            submenu: [
                {
                    text: t('NAVIGATION:ResourcesRestrictions'),
                    path: `/project/${project_id}/resources/restrictions`,
                    icon: `icon-restricciones_recurso`,
                    active: active_submenu === 'restrictions',

                },
                {
                    text: t('NAVIGATION:ResourcesCNC'),
                    path: `/project/${project_id}/resources/cnc`,
                    icon: `icon-cnc_recurso`,
                    active: active_submenu === 'cnc',
                },
                // {
                //     text: 'Carta Balance',
                //     path: `/project/${project_id}/resources/balance-chart`,
                //     icon: `icon-carta_balance`,
                //     active: active_submenu === 'balance-chart',
                //     disabled: true,
                // },
                // {
                //     text: 'Control HH',
                //     path: `/project/${project_id}/resources/control-hh`,
                //     icon: `icon-control_horas`,
                //     active: active_submenu === 'control-hh',
                //     disabled: true,
                // },
            ],
        },
        // {
        //     text: 'Protocolos',
        //     textWidth: 67,
        //     path: `/project/${project_id}/protocols`,
        //     icon: `icon-protocolos`,
        //     active: active_menu === 'protocols',
        //     disabled: true,
        // },
        {
            text: t('NAVIGATION:Indicators'),
            textWidth: 72,
            path: `/project/${project_id}/indicators/ppc`,
            icon: `icon-indicadores`,
            active: active_menu === 'indicators',
            submenu: [
                // {
                //     text: 'Dashboard',
                //     path: `/project/${project_id}/indicators/dashboard`,
                //     icon: `icon-dashboard`,
                //     active: active_submenu === 'dashboard',
                //     disabled: true,
                // },
                {
                    text: t('NAVIGATION:IndicatorsPPC'),
                    path: `/project/${project_id}/indicators/ppc`,
                    icon: `icon-ppc_indicador`,
                    active: active_submenu === 'ppc',
                },
                {
                    text: t('NAVIGATION:IndicatorsCNC'),
                    path: `/project/${project_id}/indicators/cnc`,
                    icon: `icon-cnc_recurso`,
                    active: active_submenu === 'cnc',
                },
                // {
                //     text: 'Recursos',
                //     path: `/project/${project_id}/indicators/resources`,
                //     icon: `icon-recursos_indicador`,
                //     active: active_submenu === 'resources',
                //     disabled: true,
                // },
                // {
                //     text: 'Protocolos',
                //     path: `/project/${project_id}/indicators/protocols`,
                //     icon: `icon-protocolos_indicador`,
                //     active: active_submenu === 'protocols',
                //     disabled: true,
                // },
            ],
        },
    ]

    submenu = menu.find((item: any) => item.active)?.submenu || []

    return [ menu, submenu ]
}

export default {
    getNavigation,
}
